import { Fragment } from 'react';

import clsx from 'clsx';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';

import { useHook } from './hook';

export interface IFaqItemType {
  title: string;
  value: string;
}

interface Props {
  className?: string;
  content: IFaqItemType[];
}

export const BlogFAQ: React.FC<Props> = ({ className, content }) => {
  const { activeElements, handleClick } = useHook({ content });

  return (
    <div id="accordion-collapse" className={clsx('pb-3', className)} data-accordion="open">
      {content.map((item: IFaqItemType, index: number) => {
        const key = `accordion-collapse-heading-${index + 1}`;
        const active = activeElements.includes(key);
        return (
          <Fragment key={index.toString()}>
            <button
              id={`accordion-collapse-heading-${index + 1}`}
              type="button"
              className={clsx(
                'flex w-full items-center justify-between border-b-[1px] border-b-[#382848] px-5 py-4',
                {
                  'bg-[#261B31]': active,
                  'bg-[transparent]': !active,
                },
              )}
              data-accordion-target={`#accordion-collapse-body-${index + 1}`}
              aria-expanded={active}
              aria-controls={`accordion-collapse-body-${index + 1}`}
              onClick={handleClick(key)}>
              <h3
                className="mb-1 pr-2 text-left text-[18px] font-bold leading-6 text-white md:text-[20px] lg:text-[22px] lg:leading-8"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />

              {active ? (
                <AiOutlineMinus className="text-white" />
              ) : (
                <AiOutlinePlus className="text-white" />
              )}
            </button>

            <div
              id={`accordion-collapse-body-${index + 1}`}
              className="hidden px-4 pb-4 pt-3 text-white"
              aria-labelledby={`accordion-collapse-body-${index + 1}`}
              dangerouslySetInnerHTML={{ __html: item.value }}
            />
          </Fragment>
        );
      })}
    </div>
  );
};
